import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { forEach } from 'lodash'

import {
  batchRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const relatedStuffRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const items = selector('[data-motion-item]')

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = linesRevealAnimation(pretitle, reverse)
    timeline.add(pretitleAnimation.timeline, 0)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0.1)
  }

  let itemsBatchAnimation: ScrollTrigger[]
  if (items.length) {
    itemsBatchAnimation = batchRevealAnimation({
      targets: items,
      reverse,
      delay,
      stagger: 0.08
    })
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    pretitleAnimation?.revert()
    titleAnimation?.revert()
    forEach(itemsBatchAnimation || [], (animation) => animation.kill())
  }
}
